// confirmation-dialog.component.ts
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioGroup, MatRadioButton } from "@angular/material/radio";
import { MatCheckbox } from "@angular/material/checkbox";
import { DbService } from '../service/db-service.service';

@Component({
  selector: 'app-preview-dialog',
  imports: [MatDialogModule, FormsModule, ReactiveFormsModule],
  templateUrl: './preview-dialog.component.html',
  styleUrl: './preview-dialog.component.sass'
})
export class PreviewDialogComponent implements OnInit {
  allowDelete = false;
  mode="";
  phone: string;
  previewVisible: boolean;
  previewUrl: string;
  isVideo: boolean;
  previewFileType: string;
  description: string;
  mediaid: string;
  filename: string;
  thumbfile: string;
  filetype?: string;
  constructor(public dbService: DbService,
    public dialogRef: MatDialogRef<PreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, phone: string, previewUrl: string, isVideo: boolean, previewFileType: string, description: string, isDeleteArchiveMode: boolean, mediaid: string;
      filename: string, thumbfile: string, filetype?: string}) {
        this.mediaid = data.mediaid;
        this.filename = data.filename;
        this.thumbfile = data.thumbfile
        this.filetype = data.filetype;
        this.phone = data.phone;
        this.previewUrl = data.previewUrl;
        this.isVideo = data.isVideo;
        this.previewFileType = data.previewFileType;
        this.previewVisible = true; 
        this.description = data.description;
  }

  ngOnInit(): void {}

  closePreview() {
    this.previewVisible = false;
    this.previewUrl = '';
    this.isVideo = false;
    this.previewFileType = '';
    this.dialogRef.close(false);
  }
}
